const WithdrawalStatusEnum = Object.freeze({
    Pending : 'pending',
    Queued: 'queued',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
    Declined: 'declined',
    Refunded : 'refunded'
})

export default WithdrawalStatusEnum;